<div class="mat-dialog-header">
  <h3 mat-dialog-title>Upload a deliverable</h3>
  <svg class="icon ic-20" mat-dialog-close><use href="assets/icons/icons-sprite.svg#close"/></svg>
</div>

<mat-dialog-content>

  <div class="mb-2">
    <h6 class="mb-3">Onboard someone</h6>
    <mat-form-field class="example-chip-list">
      <mat-label>Name or email</mat-label>
      <mat-chip-list #chipList aria-label="Onboard selection">
        <mat-chip
          *ngFor="let user of users"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="remove(user)">
          <div app-avatar imgSrc="assets/img/avatar.jpg" type="circle"></div>
          {{user}}
          <button matChipRemove *ngIf="removable">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <input
          placeholder="New user..."
          #userInput
          [formControl]="userCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <mat-autocomplete class="mat-option-avatar" classList="mat-option-avatar" #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let user of filteredUsers | async" [value]="user">
          <div app-avatar imgSrc="assets/img/avatar.jpg" size="sm" type="circle"></div>
          <span class="text-truncate">{{user}}</span>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

<app-upload-file [resourceDto]="data"></app-upload-file>

<app-dialog-message></app-dialog-message>

</mat-dialog-content>

<app-dialog-save-buttons [isDisabled]="this.uploadFileComponent?.currentAttachments?.length === 0 && this.uploadFileComponent?.fileUploadControl?.value?.length===0" (saveDocumentEvent)="saveDocument()"></app-dialog-save-buttons>

